import React from 'react';

import { TextField } from '@mui/material';
import { MUIFieldProps } from '../../../../../lib/types/types';

const MUITextField: React.FC<MUIFieldProps> = (props) => {
	const { label, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;

	return (
		<TextField
			id="demo-helper-text-aligned-no-helper"
			label={label}
			value={fieldValue}
			onChange={updateFieldValue}
			disabled={isDisabled}
			error={error}
			helperText={errorMessage}
			fullWidth
			{...restProps}
		/>
	);
};

export default MUITextField;
